import {
    createElementVNode as _$ce,
    map as _$ma,
    createUnknownComponentVNode as _$cc,
} from 'intact';
import {Icon} from 'kpc';


export default function($props, $blocks, $__proto__) {
    $blocks || ($blocks = {});
    $props || ($props = {});
    var $this = this;
    
    return _$ce(2, 'div', (
        _$ma(['36', 'large', 'default', 'small', 'mini'], function($value, $key) {
            return _$cc(Icon, {
                'className': 'ion-happy-outline',
                'size': $value
            });
        }, $this)
    ), 4);
};